exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_Divider_3ju4pv8pCd7GvgdfS_CnG_ {\n  display: flex;\n  width: 100%;\n  margin-bottom: 20px;\n\n}\n\n.IA_dropZones_3Lut8FUxsdILZ6zP1RcCvi {\n  width: 100%;\n  height: 20px;\n  border: 1px dashed #e0e0e0;\n  border-radius: 5px;\n  background-color: #f6f6f6;\n  float: left;\n  position: relative;\n}", ""]);

// Exports
exports.locals = {
	"IA_Divider": "IA_Divider_3ju4pv8pCd7GvgdfS_CnG_",
	"IA_dropZones": "IA_dropZones_3Lut8FUxsdILZ6zP1RcCvi"
};